/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Registry_Legal_FormInputs */

const cs_property_registry_legal_form = /** @type {(inputs: Property_Registry_Legal_FormInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Právní forma`)
};

const en_property_registry_legal_form = /** @type {(inputs: Property_Registry_Legal_FormInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legal form`)
};

/**
* | output |
* | --- |
* | "Legal form" |
*
* @param {Property_Registry_Legal_FormInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_registry_legal_form = /** @type {((inputs?: Property_Registry_Legal_FormInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Registry_Legal_FormInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_registry_legal_form(inputs)
	return cs_property_registry_legal_form(inputs)
});